export class PlayerRepairStates {
	Id: number;
	Name: 'Being Repaired' | 'Being Replaced' | 'Ok' | 'Idle' | 'Pending Completion' | 'Fickle';

	name: 'Being Repaired' | 'Being Replaced' | 'Ok' | 'Idle' | 'Pending Completion' | 'Fickle';
}